import Controller from "@ember/controller"
import { action, get } from "@ember/object"
import { inject as service } from "@ember/service"

export default class SendInAppMessageController extends Controller {
  @service("ember-store")
  store

  @service
  rpc

  @service
  session

  @service
  notifier

  inAppMessageJson = `{
  "type": "in-app-notice",
  "attributes": {
      "userId": "5397212b3263310026080000",
      "contentfulEntryId": "6h1BWuLRPG4kWKYo0I46Ik",
      "campaignId": "post-onboarding-standards"
  }
}`

  @action
  sendMessage(json) {
    get(this, "rpc")
      .execute("admin_send_in_app_message", {
        notice: JSON.parse(json),
      })
      .then(() => {
        this.notifier.success("", {
          title: "Sent!",
          message: "You rock",
          duration: 3000,
        })
      })
  }
}
